import React from 'react'
import { fromNow } from 'utils/datetime'

const SaveIndicator = ({ updatedAt, isSaving }) => {
  return (
    <span
      style={{
        color: '#b3b3b3',
        marginLeft: '1rem',
      }}
    >
      {isSaving ? `saving...` : `saved ${fromNow(updatedAt)}`}
    </span>
  )
}

export default SaveIndicator
